module.exports = __webpack_public_path__ + "static/img/close-black-54.c4ebdc29.svg";